import React from 'react';
import Empty from "../empty/Empty";

const Minimal = (props) => {
    return (
        <Empty className="viewport-container-1200" {...props} />
    );
};

export default Minimal;
